module.exports = __webpack_public_path__ + "img/paint.270329c3.svg";